import SaaRetireSurvey from "components/pages/saa/retire/Survey";
import { GetServerSidePropsContext } from "next";
import { NextPage } from "next";
import { getServerSession } from "next-auth";
import { authOptions } from "pages/api/auth/[...nextauth]";

interface Props {
  isMobile: boolean;
  surveyList: any;
}

const SaaRetireSurveyPage: NextPage<Props> = ({ isMobile, surveyList }) => {
  return <SaaRetireSurvey isMobile={isMobile} surveyList={surveyList} />;
};
export default SaaRetireSurveyPage;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { locale } = context;
  const session: any = await getServerSession(
    context.req,
    context.res,
    authOptions
  );

  // Todo : 포트폴리오 survey 결과 있는 경우 result 페이지로 이동
  const isExistSurveyResult = await fetch(
    `${process.env.NEXTAUTH_URL}/api/saa/survey?email=${session?.user?.email}&type=retire`
  );
  const isExistSurveyResultJSON = await isExistSurveyResult.json();
  const surveyList = isExistSurveyResultJSON?.surveyList;

  return {
    props: {
      surveyList,
    },
  };
}
